module.exports = __webpack_public_path__ + "static/media/ic_pagarfatura_white.edfa1c83.svg";